/*
  added form reducer - required for Redux Form to work
*/
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { employerReducers } from 'app/employer/redux/reducers';
import { reducer as toastr } from 'react-redux-toastr';
import sidebar from './sidebarReducers';
import layout from './layoutReducer';
import theme from './themeReducer';
import http from './httpReducer';
import serviceWorker from './serviceWorkerReducer';

export const rootReducer = combineReducers({
   form: formReducer,
   serviceWorker,
   sidebar,
   layout,
   theme,
   toastr,
   http,
   ...employerReducers,
});
